import React, { useState, useEffect, useRef } from 'react';
import Info from '../info/info';
import classNames from 'classnames';
import { removeNonIntegers } from '../../../util/util';

function Select(props) {
  const [showOther, setShowOther] = useState(false);
  const [otherValue, setOtherValue] = useState('');
  const [selectorValue, setSelectorValue] = useState('');
  const refContainer = useRef(null);

  useEffect(() => {

    if (props.value) {
      const existingOption = props.options.filter(x => x.value === props.value)[0]
      if (parseInt(existingOption?.value || '0') > 0) {
        setSelectorValue(props.value);
        setShowOther(false);
      }
      else {
        setSelectorValue("0");
        setShowOther(true);
      }
      let otherValue = props.value;
      if (otherValue === "0") {
        otherValue = "";
      }
      setOtherValue(otherValue);
    }
  }, [props.value, props.options]);

  // Function associated with select drop down menu
  const handleSelectorChange = e => {
    setSelectorValue(e.target.value); // Component internal state
    setOtherValue('');
    updateInputValue(e);
  };

  // Function associated with conditionally rendered input field for entering
  // custom values when 'Other' is selected
  const handleInputChange = e => {
    setOtherValue(e.target.value);
    updateInputValue(e);
  };


  const updateInputValue = (e) => {
    refContainer.current.value = removeNonIntegers(e.target.value);
    refContainer.current.dispatchEvent(new Event("input", { bubbles: true }))
  }

  return (
    <>
      <input type="hidden" name={props.name} ref={refContainer} onInput={(e) => props.onChange(e)} />
      <div className="input-group mb-3">
        <select
          value={selectorValue}
          className={
            // hasProps is custom error prop passed from builder.js, stepN.js
            classNames('form-control', { 'is-invalid': props.error })
          }
          name={props.name + "Selector"}
          placeholder={props.placeholder}
          onChange={handleSelectorChange}
        >
          <option value="" disabled hidden>
            {props.placeholder ? props.placeholder : 'Select One'}
          </option>
          {props.options.map(option => {
            return (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            );
          })}
        </select>
        {props.info ? (
          <div className="input-group-append">
            <Info>{props.info}</Info>
          </div>
        ) : null}
      </div>
      {showOther ? (
        <div>
          <p>{props.otherText}</p>
          <input
            className='form-control col-md-6'
            placeholder={props.otherPlaceholder ? props.otherPlaceholder : "Please enter a value."}
            value={otherValue}
            onChange={handleInputChange}
          />
        </div>
      ) : null}
    </>
  );
}

export default Select;
